import React from 'react'
import PropTypes from 'prop-types'
import { AlertTriangle } from '@entrata/portals-common/lib/icons'
import {
  StyledLoaderDiv,
  StyledContentDiv,
  StyledH3,
  StyledLoaderP,
} from './atoms'

const ModuleError = ({ content, title }) => (
  <StyledLoaderDiv>
    <StyledContentDiv>
      <AlertTriangle size={48} />
      <StyledH3>{title}</StyledH3>
      <StyledLoaderP>{content}</StyledLoaderP>
    </StyledContentDiv>
  </StyledLoaderDiv>
)

ModuleError.propTypes = {
  content: PropTypes.string,
  title: PropTypes.string,
}

ModuleError.defaultProps = {
  content: __(
    'There was a problem loading this content. We have logged the issue with our development team. Please try again later.',
  ),
  title: __('An error occurred'),
}

export default ModuleError
